import { useEffect, useState } from 'react';
import { getEnterFlow2026Value } from 'utils/ab-test/abTests';

type SkipChooseYourPlanGroup = ReturnType<typeof getEnterFlow2026Value>;

/** The group is only knowable in the browser, so it is read in an effect to keep server and client renders in sync.
 * Callers should wait for isLoaded before rendering anything that differs between groups. */
export const useSkipChooseYourPlan = () => {
  const [group, setGroup] = useState<SkipChooseYourPlanGroup | undefined>(
    undefined,
  );

  useEffect(() => {
    setGroup(getEnterFlow2026Value());
  }, []);

  return {
    group,
    shouldSkipChooseYourPlan:
      group === 'NewHomeBoost' ||
      group === 'NewHomePickNumbers' ||
      group === 'NewHomeBuildMembership',
    isLoaded: group !== undefined,
  };
};
